import { render, staticRenderFns } from "./AccountStatus.vue?vue&type=template&id=68d55940&scoped=true&"
import script from "./AccountStatus.vue?vue&type=script&lang=js&"
export * from "./AccountStatus.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/accountmove.css?vue&type=style&index=0&id=68d55940&prod&scoped=true&lang=css&"
import style1 from "./AccountStatus.vue?vue&type=style&index=1&id=68d55940&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d55940",
  null
  
)

export default component.exports